/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createAsyncThunk } from "@reduxjs/toolkit";

import OneClickApi from "~/features/oneClick/OneClickApi";
import { PostDecodePayload, PostEncodePayload } from "~/features/oneClick/types";

export const getReferrerSitesAsync = createAsyncThunk("oneClick/getReferrerSites", async () => {
  const sitesRes = await OneClickApi.getReferrerSites();

  return sitesRes.data.sites;
});

export const postEncodeAsync = createAsyncThunk("oneClick/postEncode", async (payload: PostEncodePayload) => {
  const encodeRes = await OneClickApi.postEncode(payload);

  return encodeRes.data.success.data;
});

export const postDecodeAsync = createAsyncThunk("oneClick/postDecode", async (payload: PostDecodePayload) => {
  const decodeRes = await OneClickApi.postDecode(payload);

  return decodeRes.data.success.data;
});
